/* eslint-disable */
import {
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Steps,
  Table,
  Tag,
  DatePicker,
  Space,
  Tooltip,
  Badge,
  Dropdown,
  List,
  Button,
  Radio,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
const { Step } = Steps;
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import createSorter from "@/components/createSorter";

import {
  FormOutlined,
  MenuOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { dataTo12Fn } from "@/utils/date.js";
const { RangePicker } = DatePicker;
const PUTTableHistory = forwardRef(({ statusFilter, ...props }, ref) => {
  const [tableList, setTableList] = useState([]); // 表格数据
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [selectionType] = useState("checkbox");
  const initialLoad = useRef(false);
  const [form] = Form.useForm();
  const [tableoading, setTableLoading] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const initialTableHead = {
    status: null,
    prop: null,
    workType: null,
    propUnit: null,
    address: null,
    city: null,
    job: null,
    remark: null,
    requestBy: null,
    createBy: null,
    requestNo: null,
    vendorName: null,
    sCreateTime: null,
    sCompletionDate: null,
    eCreateTime: null,
    eCompletionDate: null,
    requestByName: null,
    payType: null,
    documentOnlyReason: null,
    ids: null,
    groupSupervisor: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const [reviewMaterialsModal, setReviewMaterialsModal] = useState(false);
  const [reviewMaterialsList, setReviewMaterialsList] = useState([]);
  const [approvalState, setApprovalState] = useState({
    id: null,
    reviewStatus: "2",
    rejectReason: "",
  });
  const [approvalModal, setApprovalModal] = useState(false);
  const [clockList, setClockList] = useState([]);
  const [closkModal, setCloskModal] = useState(false);
  const idParamsRef = useRef(null);
  const items = [
    {
      key: "edit",
      icon: <FormOutlined style={{ color: "#00c0ef ", fontSize: "17px" }} />,
      label: <div>Edit Approval Information</div>,
    },
  ];
  const handleOk = (dates, e) => {
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("MM/DD/YYYY");
      const endDate = dates[1].format("MM/DD/YYYY");
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();
      console.log("dates......>", startTime, endTime);
      handleApiCall(startDate, endDate, startTime, endTime);
      setSelectedDateRange({
        startDate: dates[0],
        endDate: dates[1],
        startDateString: startDate,
        endDateString: endDate,
      });
    } else {
      return;
    }
  };

  const handleApiCall = async (startDate, endDate, startTime, endTime) => {
    console.log("Fetching data for:", startDate, endDate);

    setTableHead((prev) => {
      console.log("prev", prev);
      const updatedTableHead = {
        ...prev,
        sCreateTime: startTime,
        eCreateTime: endTime,
      };
      console.log("Updated tableHead:", updatedTableHead);
      fetchData(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };
  // 列表定义：
  const createInputHandler = (fieldName) => (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [fieldName]: inputValue };
        fetchData(1, 25, updatedTableHead);
        return updatedTableHead;
      });
    }
  };

  const createSelectHandler = (fieldName) => (value) => {
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, [fieldName]: value };
      fetchData(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };

  const createSearchableColumn = (
    title,
    dataIndex,
    width = 100,
    extraProps = {}
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <div>
          <Input
            placeholder={`Search ${title}`}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={createInputHandler(dataIndex)}
          />
        </div>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    sorter: createSorter(dataIndex),
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
    render:
      extraProps.render ||
      ((text) => (
        <Tooltip title={text} classNames="my-tooltip">
          <div
            className="text-clamp"
            style={{ whiteSpace: "normal", width: `${width}px` }}
          >
            {text}
          </div>
        </Tooltip>
      )),
  });

  // 创建带有选择器的列
  const createSelectableColumn = (
    title,
    dataIndex,
    options,
    width = 100,
    extraProps = {}
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <div>
          <Select
            value={tableHead[dataIndex]}
            defaultValue="All"
            placeholder={`Select ${title}`}
            style={{ width }}
            onClick={(e) => e.stopPropagation()}
            onChange={createSelectHandler(dataIndex)}
            options={options}
          />
        </div>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    sorter: createSorter(dataIndex),
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
  });
  const createJobsColumn = (width = 150, extraProps = {}) => ({
    ...createSearchableColumn("Job Type", "jobs", width, {
      ...extraProps,
      render: (text, record) => (
        <Flex gap="4px 0" wrap>
          {record.jobs?.map((item, idx) => (
            <Tooltip key={`job-${idx}`} title={item}>
              <Tag
                color="blue"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: `${width - 20}px`,
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    }),
  });
  /**
   * 创建日期选择列（单个日期选择器）
   */
  const createDateColumn = (
    title,
    dataIndex,
    width = 100,
    extraProps = {}
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <div>
          <DatePicker
            placeholder={`Select ${title}`}
            style={{ width: width - 10 }}
            onChange={(date) => {
              if (date) {
                setTableHead((prev) => {
                  const updated = { ...prev, [dataIndex]: date.valueOf() };
                  fetchData(1, 25, updated);
                  return updated;
                });
              }
            }}
          />
        </div>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
    render: (text) =>
      isValidDate(text) ? moment(text).format("MM/DD/YYYY") : "",
  });

  /**
   * 创建日期范围列（用于Create Time）
   */
  const createDateRangeColumn = (
    title,
    dataIndex,
    width = 250,
    extraProps = {}
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <Space direction="vertical">
          <RangePicker
            style={{ width: width - 20 }}
            onChange={(dates) => handleOk(dates)}
            format="MM/DD/YYYY"
          />
        </Space>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
    render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
  });

   const actualCompletionDateColumn = (
    title,
    dataIndex,
    width = 250,
    extraProps = {}
  ) => ({
    title: (
      <div>
        <div>{title}</div>
        <Space direction="vertical">
          <RangePicker
            style={{ width: width - 20 }}
            onChange={(dates) => handleOk(dates)}
            format="MM/DD/YYYY"
          />
        </Space>
      </div>
    ),
    dataIndex,
    key: dataIndex,
    width,
    className: "custom-sort-header",
    align: "center",
    ...extraProps,
    render: (text) => moment(text).format("MM/DD/YYYY "),
  });

  const createRequestedByColumn = (width = 100, extraProps = {}) => ({
    ...createSelectableColumn(
      "Requested By",
      "requestByName",
      [
        { value: "", label: "All" },
        { value: "1", label: "Tenant" },
        { value: "2", label: "Manager" },
      ],
      width,
      extraProps
    ),
  });

  // 定义列，包括输入框
  const initColumns = [
    // {
    //   title: "#",
    //   key: "#",
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 50,
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1,
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 50,
      render: (text, record) => (
        <Badge count={record.messageCount} offset={[6, -6]} size={"small"}>
          <Dropdown
            menu={{
              items: [
                {
                  key: "ReviewMaterials",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: "Review Materials",
                },
                {
                  key: "InvoiceJobHistory",
                  icon: (
                    <HistoryOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: "Invoice Job History",
                },
              ],
              onClick: (e) => badgeFn(record, e),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        </Badge>
      ),
    },
    createSearchableColumn("Request No", "requestNo", 180),
    {
      title: (text, record, index) => (
        <div>
          <div>Status</div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      hidden: false,
      width: 100,
      sorter: createSorter("status"),
      className: "custom-sort-header",
      render: (text, record, index) => {
        let statusText = "";
        let tagColor = "";
        if (text == "Ready To Pay") {
          statusText = "Ready To Pay";
          tagColor = "#00a65a";
        } else if (text == "Document Only") {
          statusText = "Document Only";
          tagColor = "#3c8dbc";
        }
        return (
          <a onClick={(e) => showModalOpen(record)}>
            <Tag color={tagColor}>{statusText}</Tag>
          </a>
        );
      },
    },
         actualCompletionDateColumn("Completed Date ", "actualCompletionDate", 200, { hidden: false }),
         createSearchableColumn("invoice Count ", "invoiceCount", 80),
          createDateRangeColumn("Created Time", "createTime", 250, { hidden: false }),
       createJobsColumn(150, { hidden: false }),
        createSearchableColumn("Remark", "remark", 100),
          createSelectableColumn("Material","isMaterials",
      [
        { value: "", label: "All" },
        { value: "1", label: "Yes" },
        { value: "2", label: "No" },
      ],
      100,
      {
        hidden: statusFilter !== "Ready To Pay",
        render: (text) => {
          const isMaterials = {
            1: "Yes",
            2: "No",
          };
          return text ? isMaterials[text] || " " : " ";
        },
      }
    ),

    createSearchableColumn("Doc.Only Reason", "documentOnlyReason", 120, {
      hidden: statusFilter !== "Document Only",
    }),
    createSelectableColumn(
      "Vendor Type",
      "workType",
      [
        { value: "", label: "All" },
        { value: "1", label: "Maint.Woker" },
        { value: "2", label: "Contractor" },
      ],
      100,
      {
        hidden: statusFilter !== "Ready To Pay",
        render: (text) => {
          const workTypeMap = {
            1: "Maint.Woker",
            2: "Contractor",
          };
          return text ? workTypeMap[text] || " " : " ";
        },
      }
    ),
    createSearchableColumn("Vendor Name", "vendorName", 100, {
      hidden: statusFilter !== "Ready To Pay",
    }),
    createDateColumn("Predicted Date", "completionDate", 150, {
      hidden: statusFilter !== "Ready To Pay",
    }),
    // createSearchableColumn("Prop-Unit", "propUnit", 100),
    createSearchableColumn("Unit Address", "address", 150),
    createSearchableColumn("City", "city", 100),

 
    createSearchableColumn("Group Supervisor", "groupSupervisor", 100),
    createRequestedByColumn(100, { hidden: false }),
    createSearchableColumn("Create By", "createByName", 100),

  ];
  const [columns, setColumns] = useState(() => {
    return initColumns.map((col) => {
      const column = { ...col };
      if (col.dataIndex === "#") {
        column.render = (text, record, index) =>
          (pagination.current - 1) * pagination.pageSize + index + 1;
      }
      return column;
    });
  });
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  // 时间非空判断
  const isValidDate = (e) => {
    return e && !isNaN(new Date(e));
  };

  const badgeFn = (record, item) => {
    const fnMatch = {
      ReviewMaterials: reviewMaterialsModalFn,
      InvoiceJobHistory: invoiceJobHistoryFn,
      Prop: (record) => {
        console.log(record);
        showOpen({
          propId: record.propId,
          type: "Prop",
        });
      },

      Unit: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          type: "Unit",
        }),

      Tenant: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          tenantId: record.tenantId,
          type: "Tenant",
        }),
    };

    if (fnMatch[item.key]) {
      fnMatch[item.key](record);
    }
  };
  const invoiceJobHistoryFn = async ({ id }) => {
    const response = await http.get(`${api.getClockList}?maintenanceId=${id}`);
    if (response.code === "1") {
      setClockList(response.data || []);
      setCloskModal(true);
    }
  };

  const reviewMaterialsModalFn = async ({ id }) => {
    const response = await http.get(
      `${api.showMaterialsByMaintenanceId}?maintenanceId=${id}`
    );
    if (response.code === "1") {
      setReviewMaterialsList(response.data || []);
      setReviewMaterialsModal(true);
    }
  };

  const approvalFn = (item) => {
    setApprovalState({
      ...approvalState,
      id: item.id,
      maintenanceId: item.maintenanceId,
    });
    setApprovalModal(true);
  };

  const approvalSubmitFn = async () => {
    const response = await http.post(`${api.reviewMaterials}`, approvalState);
    if (response.code === "1") {
      reviewMaterialsModalFn({ id: approvalState.maintenanceId });
    } else {
      Modal.confirm({
        title: null,
        // icon: <ExclamationCircleOutlined />,
        content: response.msg,
        footer: null,
        closable: true,
        maskClosable: true,
      });
    }
    approvalModalCancel();
  };

  const approvalModalCancel = () => {
    setApprovalModal(false);
    setApprovalState({
      id: null,
      reviewStatus: "2",
      rejectReason: "",
    }); 
  };

  //列表
  const fetchData = async (current, pageSize, tableHead = {}) => {
    try {
      setTableLoading(true);
      const hash = window.location.hash;
      const queryStart = hash.indexOf("?");

      let ids = null;
      let statusFilterFromUrl = null;

      if (queryStart !== -1) {
        const queryString = hash.substring(queryStart + 1);
        const searchParams = new URLSearchParams(queryString);
        ids = searchParams.get("ids");
        statusFilterFromUrl = searchParams.get("statusFilter");
      }
     const currentIdParams = idParamsRef.current || {};
      const params = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
       orderField: "supervisor",
        orderType: "desc",
        type: statusFilterFromUrl || statusFilter,
        ...tableHead,
          ...currentIdParams,
        ...(ids ? { ids } : {}),
      };

      console.log("Request params:", params);
      const response = await http.get(api.getShowPut, { params });
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));

      setTableList(dataWithKey);
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: params.page,
        total: response.data.total,
        pageSize: params.count,
      }));
    } catch (err) {
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 处理分页变化
  const handleTableChange = (newPagination, filters, sorter) => {
    fetchData(newPagination.current, newPagination.pageSize);
  };

  //复选框
  const rowSelection = {
    // 通过 getCheckboxProps 控制第一行不显示复选框
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
      disabled:
        record.status !== "Pending" ||
        (record.status === "Quoted" && materials_confirm_type === 2),
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      //选中
      console.log(selectedRowKeys);
      console.log(selectedRows);
      setSelectedList(selectedRows);
      props.deleteNum(selectedRows); //调用父组件方法
    },
  };

  //details跳转
  const showModalOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance/Details";
    const paramString = new URLSearchParams(params).toString();
    // console.log(paramString);
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

    const showOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance/PUTTable";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    // 保持原有方法
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {},
    getSearchValues: () => ({
      ...tableHead,
    }),
    newListFun: () => {
      setTableHead(initialTableHead);
      fetchData(1, 25, initialTableHead);
      setRefreshKey((prev) => prev + 1);
    },
    // 添加导出需要的方法
    getQueryParams: () => ({
      ...tableHeadRef.current,
      type: statusFilter,
      page: pagination.current,
      count: pagination.pageSize,
    }),
  }));
  // 初始化数据
  const tableHeadRef = useRef(tableHead);
const handleUrlParams = async (type, params) => {
  if (type === "Prop" && params.propId) {
    idParamsRef.current = { propId: params.propId };
  } else if (type === "Unit" && params.propId && params.unitId) {
    idParamsRef.current = {
      propId: params.propId,
      unitId: params.unitId,
    };
  } else if (type === "Tenant" && params.propId && params.unitId && params.tenantId) {
    idParamsRef.current = {
      propId: params.propId,
      unitId: params.unitId,
      tenantId: params.tenantId,
    };
  } else {
    // 如果参数不完整，不执行后续操作
    return;
  }
  await fetchData(1, pagination.pageSize, {});
};

  useEffect(() => {
    tableHeadRef.current = tableHead;
  }, [tableHead]);

useEffect(() => {
  if (!initialLoad.current) {
    initialLoad.current = true;
    const hash = window.location.hash;
    const queryStart = hash.indexOf("?");
    
    if (queryStart !== -1) {
      const queryString = hash.substring(queryStart + 1);
      const searchParams = new URLSearchParams(queryString);
      
      const type = searchParams.get("type");
      const propId = searchParams.get("propId");
      const unitId = searchParams.get("unitId");
      const tenantId = searchParams.get("tenantId");
      
      // 根据 URL 参数执行相应的逻辑
      if (type && (propId || unitId || tenantId)) {
        handleUrlParams(type, { propId, unitId, tenantId });
      }
    }
  }
}, [location.hash]);
  return (
    <div   style={{
    padding: "30px",
  }}>
      <Table
        rowClassName="table-row-gradient"
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        loading={tableoading}
        columns={initColumns.filter((col) => !col.hidden)}
        dataSource={[...filteredData]}
        pagination={{
          showQuickJumper: true,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showTotal: (total) => {
            return `Total: ${total} items`;
          },
          showSizeChanger: true,
        }}
        rowKey="id" // 唯一标识
        key={refreshKey}
        onChange={handleTableChange} // 分页、排序、筛选变化时触发
        scroll={{
          x: "max-content", //横向滚动宽度
          y: "calc(100vh - 200px)", //纵向滚动高度
        }}
        className="my-table"
      />
      <Modal
        width="50%"
        title="Review Materials"
        className="reviewMaterialsModal"
        footer={null}
        open={reviewMaterialsModal}
        onCancel={(e) => setReviewMaterialsModal(false)}
      >
        <List
          header={null}
          footer={null}
          split={true}
          className="review-materials-list"
          dataSource={reviewMaterialsList}
          renderItem={(item) => (
            <List.Item className="review-materials-item">
              <div className="RM-top">
                <div className="RM-left">
                  <div>Pick-Up Location:</div>
                  <Input.TextArea
                    autoSize
                    disabled={true}
                    value={item.storeName}
                  />
                  <div>MaterialsRemark:</div>
                  <Input.TextArea
                    autoSize
                    disabled={true}
                    value={item.materialsRemark}
                  />
                </div>
                <div className="RM-right">
                  <div className="RM-icon">
                    {/* {item.reviewStatus === 1 && <LoadingOutlined style={{color: '#f8c555'}} />} */}
                    {item.reviewStatus === 2 && (
                      <CheckOutlined style={{ color: "#18bc37" }} />
                    )}
                    {item.reviewStatus === 3 && (
                      <CloseOutlined style={{ color: "#ff0000" }} />
                    )}
                  </div>
                  <div>
                    {item.reviewStatus === 1 ? (
                      <div className="ApprovalBtn">
                        <div>Waiting For Approval</div>
                        {item.reviewStatus === 1 && (
                          <div className="RM-btn">
                            <Button
                              type="primary"
                              onClick={() => approvalFn(item)}
                            >
                              Approval
                            </Button>
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <div>{item.reviewByName}</div>
                        <div>{dataTo12Fn(item.reviewTime, 2)}</div>
                        <div>{dataTo12Fn(item.reviewTime, 3)}</div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </List.Item>
          )}
        />
      </Modal>
      <Modal
        width="50%"
        title="Do You Agree"
        footer={null}
        open={approvalModal}
        onCancel={approvalModalCancel}
      >
        <Radio.Group
          value={approvalState.reviewStatus}
          options={[
            {
              value: "2",
              label: "agree",
            },
            {
              value: "3",
              label: "refuse",
            },
          ]}
          onChange={(e) =>
            setApprovalState({ ...approvalState, reviewStatus: e.target.value })
          }
        />
        {approvalState.reviewStatus === "3" && (
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "12px" }}
          >
            <span>Reason：</span>
            <Input.TextArea
              autoSize
              value={approvalState.rejectReason}
              onChange={(e) =>
                setApprovalState({
                  ...approvalState,
                  rejectReason: e.target.value,
                })
              }
              placeholder="input rejectReason"
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <Button type="primary" onClick={() => approvalSubmitFn()}>
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        width="50%"
        title="Invoice Job History"
        footer={null}
        open={closkModal}
        onCancel={() => setCloskModal(false)}
      >
        <div className="IJH-list">
          {clockList.length ? (
            clockList.map((item) => (
              <div key={item.id} className="IJH-item">
                <span>Time: </span>
                <span className="IJH-time">{dataTo12Fn(item.clockTime)}</span>
              </div>
            ))
          ) : (
            <div className="IJH-noData">no data</div>
          )}
        </div>
        <div class="IJH-btn">
          <Button type="primary" onClick={() => setCloskModal(false)}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
});
export default PUTTableHistory;
